import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CountDown from 'components/participates/countDown';
import LoaderCP from 'components/loader';
import { MEMBER_URL, SUBASTAS_URL } from '../../constants/Constants';

const ItemNotifyMe = () => {
  const navigate = useNavigate();
  const { status } = useSelector((state) => state.user);
  // const status = 'success';
  const { detail } = useSelector((state) => state.detail);
  const { startDate, serverDate, initialOffer, urlName, id } = detail;

  const redirect = () => {
    const urlRedirect = 'notify';
    Cookies.set('redirect', urlRedirect);
  };

  const notifyMe = () => {
    localStorage.setItem('detail', JSON.stringify(detail));
    redirect();
    navigate('/notify');
  };

  const handleLogin = () => {
    localStorage.setItem('detail', JSON.stringify(detail));
    redirect();
    window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas/${urlName}/${id}`;
  };

  return (
    <>
      <div className="d-flex d-sm-none flex-column-reverse flex-sm-column pb-15 pb-sm-0">
        <div className="bg-alabaster p-sm-3 pt-sm-5 text-center notify">
          <div className="wrap py-2">
            <h3 className="text-tangaroa text-left mt-2 mt-sm-0">Oferta inicial:</h3>
            <h3 className="text-tangaroa text-left">{`${initialOffer.toLocaleString()} Puntos Aeroméxico Rewards`}</h3>
            <i className="fas fa-bell my-15" />
            <p>
              ¿Quieres que te notifiquemos cuando la Subasta haya iniciado?
            </p>
            {status === '' && <LoaderCP />}
            {status === 'success' && (
              <button
                type="button"
                className="btn btn-secondary mt-15 w-100"
                onClick={notifyMe}>
                Notificarme
              </button>
            )}
            {status === 'error' && (
              <button
                type="button"
                className="btn btn-secondary w-100 mb-15"
                onClick={handleLogin}
                id="sbs-dsb-dgr-btn-not">
                Notificarme
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="d-none d-sm-block flex-column-reverse flex-sm-column pb-15 pb-sm-0">
        <div className="mb-30 mt-30 mt-sm-0 font-weight-bold text-tangaroa">
          Inicia en:
          <CountDown
            closeDate={startDate}
            todayDate={serverDate} />
        </div>
        <div className="bg-alabaster p-0 p-sm-3 py-4 pt-sm-5 text-center d-flex">
          <div className="wrap text-tangaroa">
            <h3 className="f-600 text-left mt-2 mt-sm-0">Oferta inicial:</h3>
            <h3 className="f-600 text-left">{`${initialOffer.toLocaleString()} Puntos Aeroméxico Rewards`}</h3>
            <i className="fas fa-bell my-15" />
            <p>
              ¿Quieres que te notifiquemos cuando la Subasta haya iniciado?
            </p>
            {status === '' && <LoaderCP />}
            {status === 'success' && (
              <button
                type="button"
                className="btn btn-secondary mt-15 w-100"
                onClick={notifyMe}>
                Notificarme
              </button>
            )}
            {status === 'error' && (
              <button
                type="button"
                className="btn btn-secondary w-100 mb-15"
                onClick={handleLogin}
                id="sbs-dsb-dgr-btn-not">
                Notificarme
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemNotifyMe;
